export default __webpack_public_path__ + "static/media/tabi-life-white.805554e7.svg";